import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LogoProvider } from "@/contexts/LogoContext";
import SiteLayout from "@/components/site/SiteLayout";
import ScrollToTopOnNav from "@/components/site/ScrollToTopOnNav";
import HomePage from "@/pages/HomePage";

const AProposPage = lazy(() => import("@/pages/AProposPage"));
const ArreterTabacPage = lazy(() => import("@/pages/ArreterTabacPage"));
const TherapiesPage = lazy(() => import("@/pages/TherapiesPage"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const ArticlePage = lazy(() => import("@/pages/ArticlePage"));
const TagPage = lazy(() => import("@/pages/TagPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const MentionsLegalesPage = lazy(() => import("@/pages/MentionsLegalesPage"));
const PolitiqueConfidentialitePage = lazy(() => import("@/pages/PolitiqueConfidentialitePage"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const GestionPage = lazy(() => import("@/pages/GestionPage"));
const GuideArretTabacPage = lazy(() => import("@/pages/GuideArretTabacPage"));
const HubHypnosePage = lazy(() => import("@/pages/HubHypnosePage"));
const HubCoachingPage = lazy(() => import("@/pages/HubCoachingPage"));
const FAQPage = lazy(() => import("@/pages/FAQPage"));
const ConfirmationPage = lazy(() => import("@/pages/ConfirmationPage"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <LogoProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTopOnNav />
          <Suspense fallback={null}>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/a-propos" element={<AProposPage />} />
                <Route path="/therapies" element={<TherapiesPage />} />
                <Route path="/arreter-le-tabac" element={<ArreterTabacPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<ArticlePage />} />
                <Route path="/blog/tag/:tag" element={<TagPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/arreter-le-tabac/guide-complet" element={<GuideArretTabacPage />} />
                <Route path="/hypnose/guide-complet" element={<HubHypnosePage />} />
                <Route path="/coaching/guide-complet" element={<HubCoachingPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/confirmation" element={<ConfirmationPage />} />
                <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
                <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/gestion" element={<GestionPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </LogoProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
